"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncReduxSearchQuery = void 0;
const query_string_1 = __importDefault(require("query-string"));
class SyncReduxSearchQuery {
    constructor(history, store, selector, action, options) {
        this.updating = false;
        this.parseOptions = { arrayFormat: 'comma', parseNumbers: true, parseBooleans: true };
        this.stringifyOptions = { arrayFormat: 'comma' };
        this.getState = () => {
            return this.selector.call(this, this.store.getState());
        };
        this.addToLocation = (query) => {
            if (this.updating)
                return;
            const search = query_string_1.default.stringify(query, this.stringifyOptions);
            // dont push if new query string equals current query string
            if ('?' + search === this.history.location.search)
                return;
            this.updating = true;
            this.history.push({
                search,
            });
            this.updating = false;
        };
        this.locationToStore = (location) => {
            if (this.updating)
                return;
            this.updating = true;
            const query = query_string_1.default.parse(location.search, this.parseOptions);
            const action = this.action.call(this, Object.assign({}, query)); // for some reasons query is not serializable, so we make it serializable
            this.store.dispatch(action);
            this.updating = false;
        };
        this.stop = () => {
            if (!this.store)
                return;
            this.unsubscribe();
            this.unlisten();
            // @ts-ignore
            this.store = null;
            // @ts-ignore
            this.history = null;
            // @ts-ignore
            this.selector = null;
            // @ts-ignore
            this.action = null;
            // @ts-ignore
            this.unsubscribe = null;
            // @ts-ignore
            this.unlisten = null;
            this.previousState = null;
            this.previousSearch = null;
        };
        this.history = history;
        this.store = store;
        this.selector = selector;
        this.action = action;
        this.previousState = this.getState();
        this.previousSearch = this.history.location.search;
        if (options && options.parseOptions) {
            this.parseOptions = options.parseOptions;
        }
        if (options && options.stringifyOptions) {
            this.stringifyOptions = options.stringifyOptions;
        }
        this.unsubscribe = this.store.subscribe(() => {
            const state = this.getState();
            if (this.previousState !== state) {
                this.addToLocation(state);
                this.previousState = state;
            }
        });
        this.unlisten = this.history.listen((location) => {
            if (this.previousSearch !== location.search) {
                this.locationToStore(location);
                this.previousSearch = location.search;
            }
        });
        if (history.location.search) {
            const state = Object.assign({}, this.getState(), query_string_1.default.parse(history.location.search, this.parseOptions));
            this.store.dispatch(this.action.call(this, state));
        }
    }
}
exports.SyncReduxSearchQuery = SyncReduxSearchQuery;
function syncReduxSearchQuery(history, store, selector, action) {
    return new SyncReduxSearchQuery(history, store, selector, action).stop;
}
exports.default = syncReduxSearchQuery;
